const action = {
    general: 'เกิดข้อผิดพลาดขณะเรียกใช้การดำเนินการ โปรดลองอีกครั้งในภายหลัง',
    sign_in_identifier_changed: 'การดำเนินการไม่สามารถเปลี่ยนตัวระบุการเข้าสู่ระบบที่ใช้ในการตรวจสอบนี้ได้',
};
export default Object.freeze(action);
